export enum AcceptanceCriteriaType {
    None = 0,
    CommonAcceptanceCriteria = 1,
    LowestLevel = 2,
    AcceptanceCriteriaNotAvailable = 3
}

export namespace AcceptanceCriteriaType {
    export function toString(): string;
    export function toString(level: AcceptanceCriteriaType): string;
    export function toString(level?: AcceptanceCriteriaType): string {
        return level !== null ? AcceptanceCriteriaType[level] : Object.prototype.toString.call(AcceptanceCriteriaType);
    }

    export function toName(enumValue: AcceptanceCriteriaType): string {
        switch (enumValue) {
            case AcceptanceCriteriaType.None:
                return 'Not Configured';
            case AcceptanceCriteriaType.CommonAcceptanceCriteria:
                return 'Common Acceptance Criteria';
            case AcceptanceCriteriaType.LowestLevel:
                return 'Lowest Level';
            case AcceptanceCriteriaType.AcceptanceCriteriaNotAvailable:
                return 'Acceptance Criteria not Available';
        }
    }
}
